module.exports = __webpack_public_path__ + "static/image/history/m/201803@3x.ver2_0_2.jpg?b92aee2e";